/* ==========================================================================
   IRON FIT - Tool sets

   Tools are simple: one photo, a short spec, one price. They don't need the
   spin viewer or a detail page each, so the card IS the product - it carries
   the features and adds straight to the cart.

   Copy and prices come from the live store's own product feed
   (03-PRODUCTS/products.json).
   ========================================================================== */
(function () {
  'use strict';

  var TOOLS = [
    {
      name: '46-Piece Socket & Ratchet Set',
      tag: 'Strong. Compact. Ready.',
      price: 25,
      img: 'assets/tool-socket46-760.jpg',
      key: 'tool-socket46',
      features: [
        '46 pieces - sockets, bits, ratchet, extensions',
        'Quick-release ratchet handle',
        'Compact hard latching case'
      ]
    },
    {
      name: '115-in-1 Precision Screwdriver Set',
      tag: 'One kit. Every repair.',
      price: 29,
      img: 'assets/tool-precision115-760.jpg',
      key: 'tool-precision115',
      features: [
        '115 hardened CR-V precision bits',
        'Magnetic driver, flex shaft, tweezers & opening tools',
        'Phones, laptops, consoles, watches and glasses'
      ]
    },
    {
      name: '108-in-1 Professional Tool Set',
      tag: 'Every tool. One case.',
      price: 45,
      img: 'assets/tool-pro108-760.jpg',
      key: 'tool-pro108',
      features: [
        '108 pieces - full socket range + ratchets',
        'Chrome-vanadium steel, mirror finish',
        'Heavy-duty latching case'
      ]
    },
    {
      name: '128-in-1 Complete Repair Kit',
      tag: 'One kit. Endless fixes.',
      price: 59,
      img: 'assets/tool-repair128-760.jpg',
      key: 'tool-repair128',
      features: [
        '128 pieces - bits, sockets, precision drivers',
        'Rugged organised roll case',
        'Home, phone and electronics repair'
      ]
    }
  ];

  function money(n) { return window.IFZCart.money(n); }

  function card(t) {
    var el = document.createElement('article');
    el.className = 'acc acc--tool';

    var media = document.createElement('span');
    media.className = 'acc__media acc__media--tool';
    var pic = window.IFZPic(t.img);
    var img = pic.querySelector('img');
    img.alt = t.name;
    /* This page was pulling 951 KB of photographs, every one of them eager
       and far larger than the slot it lands in — the originals were 1043x764
       for a box about 355x266, nearly nine times the pixels. That download
       plus four main-thread decodes is what made it feel slow.

       The -760 files are the same shots resized to twice the display width,
       which is plenty for a retina phone and 55% lighter. Lazy defers what is
       below the fold, async keeps the decode off the main thread, and the
       intrinsic size reserves the space so the cards cannot jump.

       The full-size originals are left in place — other pages use them. */
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 760;
    img.height = 557;
    media.appendChild(pic);

    var body = document.createElement('span');
    body.className = 'acc__body';

    var tag = document.createElement('span');
    tag.className = 'acc__tag';
    tag.textContent = t.tag;

    var nm = document.createElement('b');
    nm.className = 'acc__name';
    nm.textContent = t.name;

    var ul = document.createElement('ul');
    ul.className = 'acc__list';
    t.features.forEach(function (f) {
      var li = document.createElement('li');
      li.textContent = f;
      ul.appendChild(li);
    });

    var foot = document.createElement('span');
    foot.className = 'acc__foot';
    var price = document.createElement('span');
    price.className = 'acc__price';
    price.innerHTML = money(t.price) + ' <em>Delivered</em>';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'acc__add';
    btn.textContent = 'Add to cart';

    var added = false;
    btn.addEventListener('click', function () {
      if (added) { window.location.href = window.IFZU('cart-revamp.html'); return; }
      window.IFZCart.add({
        type: 'tool',
        name: t.name,
        price: t.price,
        img: t.img,
        key: t.key,
        extras: [],
        includes: ['Delivery to your home - all Lebanon']
      });
      added = true;
      el.classList.add('is-added');
      btn.textContent = 'Added! View cart ->';
    });

    foot.appendChild(price);
    foot.appendChild(btn);

    body.appendChild(tag);
    body.appendChild(nm);
    body.appendChild(ul);
    body.appendChild(foot);

    el.appendChild(media);
    el.appendChild(body);
    return el;
  }

  function init() {
    var grid = document.getElementById('toolGrid');
    if (!grid) return;
    TOOLS.forEach(function (t) { grid.appendChild(card(t)); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
